<template>
  <v-app>
    <v-main :is="this.$route.meta.layout || 'div'">
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    //
  }),
};
</script>
